
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/[tool]",
      function () {
        return require("private-next-pages/tools/[tool].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/[tool]"])
      });
    }
  